import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckbox, MatCheckboxChange } from '@angular/material';

import { BooleanFilter, FilterComponentBase } from '../filters/filters';


@Component({
  selector: 'app-checkbox-filter',
  templateUrl: './checkbox-filter.component.html',
  styleUrls: ['./checkbox-filter.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxFilterComponent),
      multi: true
    },
    {
      provide: FilterComponentBase,
      useExisting: forwardRef(() => CheckboxFilterComponent)
    }
  ]
})
export class CheckboxFilterComponent extends FilterComponentBase implements OnInit, ControlValueAccessor {
  @Input() filter: BooleanFilter;
  @Input() compact: boolean;
  @Input() label: string;
  @Input() fontSet: string;
  @Input() fontIcon: string;
  @Input() svgIcon: string;
  @Input() icon: string;
  @Output() change = new EventEmitter<any>();

  @ViewChild('checkbox') checkbox: MatCheckbox;
  private onChangeCallback = (_: any) => {};

  ngOnInit() {
    this.checkbox.change.subscribe((e: MatCheckboxChange) => {
      this.onChangeCallback(e.checked);
      this.change.emit(e.checked);
    });
  }

  writeValue(value: any): void {
    if (value !== undefined) {
      this.filter.enabled = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.checkbox.registerOnTouched(fn);
  }
}
